<template>
  <div>
    <div class="footer_bar">
      <!-- 底部输入区 -->
      <input
        type="text"
        placeholder="欢迎发表你的评论"
        placeholder-style="color:#a7a7a7;"
        @click="handleInput"
        readonly
        :class="isShow == true ? '' : 'pr'"
      />
      <div class="footer_right">
        <div
          class="comment"
          :class="isShow == true ? '' : 'pr'"
          @click="jumpComments"
        >
          <img src="http://img.wish.hebyun.com.cn/images/footer_comment.png" />
          <!-- <span class="red" v-if="comment_count !== 0">{{
            comment_count > 99 ? "99+" : comment_count
          }}</span> -->
          <van-badge :content="comment_count" max="99" v-if="comment_count !== 0">
            <div class="child" />
          </van-badge>
        </div>
        <!-- .van-badge--fixed -->
        <div class="collect" @click="handleCollect" v-if="isShow">
          <img
            :src="
              is_collect == 1
                ? 'http://img.wish.hebyun.com.cn/images/footer_collect_active.png'
                : 'http://img.wish.hebyun.com.cn/images/footer_collect.png'
            "
          />
        </div>
        <div class="share" @click="share">
          <img src="http://img.wish.hebyun.com.cn/images/footer_share.png" />
        </div>
      </div>
    </div>
    <van-popup
      v-model="showPopup"
      position="bottom"
      :style="{ height: '165px' }"
    >
      <div class="shuru">
        <van-field
          ref="content"
          v-model="comment"
          rows="3"
          autosize
          type="textarea"
          maxlength="120"
          placeholder="请发表你的留言"
          show-word-limit
        />
        <div class="fasong" @click="handleSubmit">发送</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: ["comment_count", "is_collect", "pagetype", "module", "id"],
  data() {
    return {
      state: 0,
      isShow: true,
      showPopup: false,
      comment: "", //评论
    };
  },
  created() {
    if (this.pagetype === "fruitPage") {
      this.isShow = false;
    } else if (this.pagetype === "wishPage") {
      this.isShow = true;
    }
  },
  methods: {
    // 关注 wishid:心愿id
    // state:0收藏1取消
    async handleCollect() {
      if (this.is_collect === 0) {
        this.state = 0;
      } else if (this.is_collect === 1) {
        this.state = 1;
      }

      await this.$api.collectWish({
        wishid: this.id,
        state: this.state,
      });
      if (this.is_collect === 0) {
        this.$toast("关注成功");
        this.is_collect = 1;
      } else {
        this.$toast("取消关注");
        this.is_collect = 0;
      }
      this.$emit("refresh");
    },
    // 点击输入框，弹出输入弹框
    handleInput() {
      if (this.isLogin()) {
        this.showPopup = true;
      } else {
        window.location.href =
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun";
      }
    },
    // 点击发送
    async handleSubmit() {
      if (this.comment.trim().length === 0) {
        this.$toast("请输入内容");
        return;
      }
      let data = {
        module: this.module,
        id: this.id,
        comment: this.comment,
      };
      await this.$api.publishComment(data);
      this.$toast("发送成功,审核通过后可见");
      this.comment = "";
      this.showPopup = false;
    },
    // 分享
    share() {
      var msg = {
        shareTitle: "党员微心愿",
        shareSummary: "党员微心愿",
        shareUrl: "http://www.hebei.com.cn/",
        shareImage:
          "http://pic1.hebei.com.cn/003/022/280/00302228046_c01a998c.jpg",
      };
      window.jsInterface.nativeShare(JSON.stringify(msg));
    },
    // 点击底部评论图标
    jumpComments() {
      if (this.comment_count > 0) {
        this.$router.push({
          path: "./comments",
          query: {
            id: this.id,
            module: this.module,
          },
        });
      } else {
        this.$toast("暂无评论");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 底部固定区 */
.footer_bar {
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  width: 375px;
  height: 55px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  input {
    width: 233px;
    height: 38px;
    background-color: #f6f6f6;
    border-radius: 38px;
    font-size: 14px;
    line-height: 38px;
    letter-spacing: 0.5px;
    color: #333333;
    padding-left: 19px;
    box-sizing: border-box;
    outline: none;
    border: none;
  }
  input.pr {
    width: 260px;
  }
}

.footer_right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /deep/ .van-badge--fixed{
    top: -18px;
  }
  .comment {
    position: relative;
    img {
      width: 19px;
      height: 18.5px;
    }
    .red {
      display: block;
      position: absolute;
      right: -6px;
      top: 2px;
      width: 14px;
      height: 14px;
      background-color: #ff0000;
      font-size: 11px;
      line-height: 17px;
      letter-spacing: 0.5px;
      color: #fffefe;
      border-radius: 10px;
    }
  }
  .comment.pr {
    margin-right: 20px;
  }
  .collect {
    margin: 0 18px;
    img {
      width: 24px;
      height: 23px;
    }
  }
  .share {
    img {
      width: 20px;
      height: 20px;
    }
  }
}
.shuru {
  width: 90%;
  margin: 10px auto;
  .fasong {
    width: 80px;
    height: 30px;
    background-color: #e60012;
    border-radius: 10px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    float: right;
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items:center;
  }
  /deep/.van-cell {
    height: 100px;
    background-color: #e9e9e9;
    border-radius: 10px;
    padding: 10px;
    /deep/.van-field__body {
      height: 90%;
    }
    /deep/.van-field__control {
      height: 90px !important;
      font-size: 14px;
      line-height: 26px;
    }
    /deep/.van-field__word-limit {
      font-size: 11px;
      margin-top: 0;
    }
  }
}
</style>
